import { Box, type BoxProps } from '@mui/material'

import { color } from '@/v2/design-system/tokens'

/** Superficie "hundida" respecto al canvas — para contenido incrustado
 * dentro de otra superficie (p. ej. un mapa compacto dentro de un panel) sin
 * apilar un segundo borde/sombra sobre el contenedor padre. */
export function InsetSurface({ sx, ...props }: BoxProps) {
  return (
    <Box
      sx={{
        borderRadius: 2,
        bgcolor: color.canvas,
        border: `1px solid ${color.border}`,
        overflow: 'hidden',
        ...sx,
      }}
      {...props}
    />
  )
}
